/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import {
  TenkoDetailContext,
  TenkoHeaderContext,
  TenkoKubunContext,
  UpsertTenkoDetailFunctionContext,
  ZyomuinContext,
} from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"
import BusyoService from "../../../../service/master/busyo/busyoService"
import SikutyosonService from "../../../../service/master/sikutyoson/sikutyosonService"
import { T市区町村 } from "../../../../service/master/sikutyoson/TSikutyoson"
import { T点呼区分, e点呼区分 } from "../../../../constant/enum/unko"
import {
  selectAlcoholCheckPage,
  selectMenkyoUmuPage,
  selectNitizyoTenkenPage,
} from "../../../../constant/tablet/pages"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faMicrophone,
  faPen,
  faWaveSquare,
} from "@fortawesome/free-solid-svg-icons"
import { ModalOuter } from "../../../../components/Tablet/ModalOuter"
import { setAlerts } from "../../../../globalStore/alertStore"
import { AppDispatch } from "../../../.."
import { useDispatch } from "react-redux"
import { e点呼確認 } from "../../../../constant/enum/unko"
import { TTenkoDetailUpsertReq } from "../../../../service/truckcontrol/tenko/TTenko"
import { 区分分類コード } from "../../../../constant/enum/codes"
import KubunService from "../../../../service/master/kubun/kubunService"
import { 区分マスタ } from "../../../../service/master/kubun/TKubun"
import { showToast } from "../../../../components/Tablet/TabletToast"
import SpinnerInTablet from "../../../../components/SpinnerInTablet"

const SelectTenkoBasyo = () => {
  const history = useHistory()
  const dispatch: AppDispatch = useDispatch()

  const { 点呼ヘッダ情報 } = useContext(TenkoHeaderContext)
  const { 点呼区分 } = useContext(TenkoKubunContext)
  const { 乗務員 } = useContext(ZyomuinContext)
  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)
  const UpsertTenkoDetail = useContext(UpsertTenkoDetailFunctionContext)

  const [点呼市区町村, set点呼市区町村] = useState<T市区町村>()
  const [点呼場所名, set点呼場所名] = useState<string>()
  const [音声取得中, set音声取得中] = useState(false)
  const [音声解析中, set音声解析中] = useState(false)
  const [共通指示事項List, set共通指示事項List] = useState<区分マスタ[]>()
  const [指示事項, set指示事項] = useState<区分マスタ>()

  const [市区町村List, set市区町村List] = useState<T市区町村[]>()
  const [isSearching, setIsSearching] = useState(false)

  const [音声入力modalShow, set音声入力ModalShow] = useState(false)
  const [文字入力modalShow, set文字入力ModalShow] = useState(false)

  const upsert点呼明細 = async (
    tenkoDetailUpsertReq: TTenkoDetailUpsertReq
  ) => {
    // 個別のフラグを設定
    switch (点呼区分?.区分コード as T点呼区分) {
      case e点呼区分.始業点呼:
      case e点呼区分.始業点呼2:
        tenkoDetailUpsertReq.日常点検フラグ = e点呼確認.日常点検.OK
        tenkoDetailUpsertReq.免許証フラグ = e点呼確認.免許証フラグ.OK
        tenkoDetailUpsertReq.疲労疾病フラグ = e点呼確認.疲労疾病フラグ.OK
        tenkoDetailUpsertReq.睡眠不足フラグ = e点呼確認.睡眠不足フラグ.OK

        // 共通指示事項
        const 共通指示事項 = 共通指示事項List?.find(
          (e) => e.区分ID === 点呼ヘッダ情報?.共通指示事項1区分ID
        )

        if (共通指示事項 != null) {
          tenkoDetailUpsertReq.共通指示事項1テキスト = 共通指示事項.名称1
          tenkoDetailUpsertReq.共通指示事項1区分ID = 共通指示事項.区分ID
        }
        break
      case e点呼区分.中間点呼１:
      case e点呼区分.中間点呼２:
      case e点呼区分.中間点呼３:
        tenkoDetailUpsertReq.疲労疾病フラグ = e点呼確認.疲労疾病フラグ.OK
        tenkoDetailUpsertReq.睡眠不足フラグ = e点呼確認.睡眠不足フラグ.OK
        break
      case e点呼区分.終業点呼:
      case e点呼区分.終業点呼2:
        tenkoDetailUpsertReq.免許証フラグ = e点呼確認.免許証フラグ.OK
        break
      default:
        break
    }

    const 新規点呼明細Res = await UpsertTenkoDetail(tenkoDetailUpsertReq, true)

    set点呼明細(新規点呼明細Res?.data)

    showToast(
      [
        ``,
        `${乗務員?.社員氏名}さんの`,
        `${点呼区分?.名称1}を`,
        <span>
          <span style={{ color: "red" }}>一時登録</span>しました
        </span>,
      ],
      {
        bodyStyle: { fontSize: "2rem" },
      }
    )
  }

  const moveNextPage = () => {
    switch (点呼区分?.区分コード as T点呼区分) {
      case e点呼区分.始業点呼:
      case e点呼区分.始業点呼2:
        history.push(selectNitizyoTenkenPage.Route.path)
        break
      case e点呼区分.中間点呼１:
      case e点呼区分.中間点呼２:
      case e点呼区分.中間点呼３:
        history.push(selectAlcoholCheckPage.Route.path)
        break
      case e点呼区分.終業点呼:
      case e点呼区分.終業点呼2:
        history.push(selectMenkyoUmuPage.Route.path)
        break
      default:
        break
    }
  }

  const move点呼明細選択 = async () => {
    setIsSearching(true)

    try {
      // 点呼明細IDがない場合一旦登録
      if (点呼明細?.点呼記録明細ID == null) {
        const tenkoDetailUpsertReq: TTenkoDetailUpsertReq = {
          ...点呼明細,
          市区町村ID: 点呼市区町村?.市区町村ID,
          団体コード: 点呼市区町村?.団体コード,
          点呼場所名: 点呼市区町村?.市区町村名漢字,
          // 点呼の確認一覧をすべてOKで一度作成する。
          AL検知器使用フラグ: e点呼確認.検知器使用フラグ.使用,
          酒気帯フラグ: e点呼確認.酒気帯びフラグ.OK,
          AL測定値: 0,
          指示事項1区分コード: 指示事項?.区分コード,
          指示事項1テキスト: 指示事項?.名称1,
        }
        await upsert点呼明細(tenkoDetailUpsertReq)
      }
      setIsSearching(false)

      moveNextPage()
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  const move点呼明細選択InModal = async () => {
    setIsSearching(true)

    // 点呼明細IDがない場合一旦登録
    if (点呼明細?.点呼記録明細ID == null) {
      const tenkoDetailUpsertReq: TTenkoDetailUpsertReq = {
        ...点呼明細,
        点呼場所名,
        // 点呼の確認一覧をすべてOKで一度作成する。
        AL検知器使用フラグ: e点呼確認.検知器使用フラグ.使用,
        酒気帯フラグ: e点呼確認.酒気帯びフラグ.OK,
        AL測定値: 0,
        指示事項1区分コード: 指示事項?.区分コード,
        指示事項1テキスト: 指示事項?.名称1,
      }
      await upsert点呼明細(tenkoDetailUpsertReq)
    }
    setIsSearching(false)

    moveNextPage()
  }

  const open音声認識Modal = () => {
    set音声入力ModalShow(true)
  }

  const open文字入力Modal = async () => {
    if (市区町村List == null || 市区町村List?.length <= 0) {
      setIsSearching(true)
      const 市区町村Res = await new SikutyosonService().getList({})

      市区町村Res && set市区町村List(市区町村Res.data)
      setIsSearching(false)
    }
    set文字入力ModalShow(true)
  }

  const 音声認識 = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition
    const recognition = new SpeechRecognition()
    recognition.lang = "ja-JP"

    recognition.onstart = () => {
      set音声取得中(true)
    }
    recognition.onspeechstart = (event) => {
      set音声解析中(true)
    }
    recognition.onspeechend = (event) => {
      set音声解析中(false)
    }

    recognition.onresult = (event) => {
      set点呼場所名(event.results[0][0].transcript)
      set音声取得中(false)
      recognition.stop()
    }

    recognition.start()
  }

  useEffect(() => {
    if (点呼ヘッダ情報 == null || 点呼ヘッダ情報.部所ID == null) return
    setIsSearching(true)

    Promise.all([
      new BusyoService().get(点呼ヘッダ情報.部所ID),
      new KubunService().getList({}),
    ])
      .then(async ([部所Res, 区分Res]) => {
        if (
          部所Res &&
          部所Res.data &&
          部所Res.data.点呼場所市区町村ID != null
        ) {
          const 市区町村Res = await new SikutyosonService().getList({
            市区町村ID: 部所Res.data.点呼場所市区町村ID,
          })
          if (市区町村Res && 市区町村Res.data && 市区町村Res.data.length === 1)
            set点呼市区町村(市区町村Res.data[0])
        }
        if (区分Res != null && 区分Res.data != null) {
          const 共通指示事項区分List = 区分Res.data.filter(
            (e) =>
              e.分類コード === 区分分類コード.運行管理_勤怠.共通指示事項区分
          )
          set共通指示事項List(共通指示事項区分List)

          // 一時登録用に指示事項取得
          const 指示事項区分List = 区分Res.data.filter(
            (e) => e.分類コード === 区分分類コード.運行管理_勤怠.指示事項区分
          )
          let ランダム指示事項Number = Math.trunc(
            指示事項区分List.length * Math.random()
          )
          let 指示事項Index =
            ランダム指示事項Number !== 0 ? ランダム指示事項Number - 1 : 0
          set指示事項(指示事項区分List[指示事項Index])
        }
      })
      .finally(() => {
        setIsSearching(false)
      })
  }, [])

  useEffect(() => {
    音声入力modalShow && 音声認識()
  }, [音声入力modalShow])

  return (
    <>
      <SpinnerInTablet searching={isSearching}></SpinnerInTablet>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>どこで点呼していますか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={move点呼明細選択}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <div>
                    <span style={{ fontSize: "2rem" }}>設置場所</span>
                  </div>
                  <div>
                    <span style={{ fontSize: "4rem" }}>
                      {点呼市区町村 && 点呼市区町村.市区町村名漢字}
                    </span>
                  </div>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={open音声認識Modal}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "4rem",
                  }}>
                  <div>
                    <span>
                      <FontAwesomeIcon icon={faMicrophone} />
                    </span>
                  </div>
                  <div>
                    <span>音声入力</span>
                  </div>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td>
              <div
                onTouchStart={open文字入力Modal}
                style={{
                  backgroundColor: "white",
                  display: "flex",
                  width: "calc(100% - 3rem )",
                  fontSize: "3rem",
                  padding: "0.5rem 1rem",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                }}>
                <div>
                  <FontAwesomeIcon icon={faPen}></FontAwesomeIcon>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}>
                  <span>文字入力</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {/* 音声入力 */}
      <ModalOuter
        isShow={音声入力modalShow}
        dialogClassName="w-75"
        setIsShow={set音声入力ModalShow}>
        <table style={{ height: "40rem", width: "100%" }}>
          <tbody>
            <tr>
              <td
                colSpan={3}
                className="text-center"
                style={{ fontSize: "3rem" }}>
                {音声取得中 && "音声認識中... 点呼場所を喋ってください"}
              </td>
            </tr>
            <tr>
              <td
                className="text-center"
                style={{
                  position: "relative",
                  fontSize: "5rem",
                }}
                colSpan={3}>
                {音声解析中 ? (
                  <div
                    style={{
                      animation:
                        "icon-noisy-wave 0.1s ease-in-out infinite alternate",
                    }}>
                    <FontAwesomeIcon icon={faWaveSquare} />
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        animation: 音声取得中
                          ? "icon-blink 1s ease-in-out infinite alternate"
                          : "",
                      }}>
                      <FontAwesomeIcon icon={faMicrophone} />
                    </div>
                    <div>
                      {!音声取得中 && 点呼場所名 != null && 点呼場所名 !== ""
                        ? 点呼場所名
                        : "喋りかけてください"}
                    </div>
                  </>
                )}
              </td>
            </tr>
            <tr className="text-center" style={{ fontSize: "4rem" }}>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    set点呼場所名(undefined)
                    set音声入力ModalShow(false)
                  }}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.OK_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>閉じる</span>
                </div>
              </td>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={音声認識}
                  style={{
                    bottom: "0",
                    visibility: 音声取得中 ? "hidden" : "visible",
                    backgroundColor: "#1eb684",
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>もう一度</span>
                </div>
              </td>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={move点呼明細選択InModal}
                  style={{
                    bottom: "0",
                    visibility:
                      点呼場所名 != null && 点呼場所名 !== ""
                        ? "visible"
                        : "hidden",
                    backgroundColor: CSS_PROPERTY.WARN_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>確定</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ModalOuter>

      {/* 文字入力 */}
      <ModalOuter
        isShow={文字入力modalShow}
        dialogClassName="w-75"
        setIsShow={set文字入力ModalShow}>
        <table style={{ height: "40rem", width: "100%" }}>
          <tbody>
            <tr>
              <td
                className="text-center"
                style={{
                  position: "relative",
                  fontSize: "5rem",
                }}
                colSpan={3}>
                点呼場所を入力してください
              </td>
            </tr>
            <tr>
              <td
                className="text-center"
                style={{
                  position: "relative",
                  fontSize: "5rem",
                }}
                colSpan={3}>
                <input
                  value={点呼場所名}
                  autoComplete="on"
                  onChange={(e) => set点呼場所名(e.target.value)}
                  list="todohukenList"
                />
                <datalist id="todohukenList">
                  {市区町村List?.map((市区町村Data) => (
                    <option
                      key={市区町村Data.市区町村ID}
                      value={市区町村Data.市区町村名漢字}>
                      {市区町村Data.市区町村名漢字}
                    </option>
                  ))}
                </datalist>
              </td>
            </tr>
            <tr className="text-center" style={{ fontSize: "4rem" }}>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    set点呼場所名(undefined)
                    set文字入力ModalShow(false)
                  }}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.OK_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>閉じる</span>
                </div>
              </td>
              <td></td>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={move点呼明細選択InModal}
                  style={{
                    bottom: "0",
                    visibility:
                      点呼場所名 != null && 点呼場所名 !== ""
                        ? "visible"
                        : "hidden",
                    backgroundColor: CSS_PROPERTY.WARN_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>確定</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ModalOuter>
    </>
  )
}

export default SelectTenkoBasyo
